import { useMutation } from "@tanstack/react-query";
import { signup as signupApi } from "../../services/apiAuth";
//import { toast } from "react-hot-toast";

export function useSignup() {
    const { mutate: signup, isLoading } = useMutation({
        mutationFn: signupApi,
        onSuccess: () => {
            alert("Account successfully created! Please verify the new account from the user's email address.");
            // toast.success(
            //     "Account successfully created! Please verify the new account from the user's email address."
            // );
        },
        onError: (error) => alert("Sign-up failed: " + error.message),
    });

    return { signup, isLoading };
}
